import { partnersBasePath } from './partners-path'

export const SEO_INTERAL_PATH = '/api/seo/properties/:id'

export const SEO_PATH = `${partnersBasePath}/seo/properties`
